import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { SnackBarModule } from '../shared/snack-bar/snack-bar.module';
import { httpInterceptorProviders } from './interceptors';
import { CoreStoreModule } from './store/store.module';

@NgModule({
  imports: [CommonModule, HttpClientModule, SnackBarModule, CoreStoreModule],
  exports: [],
  declarations: [],
  providers: [httpInterceptorProviders],
  schemas: [],
})
export class CoreModule {}
